define('modules/shell/widgets/datepicker/i18n/es',{
    "datepicker":{
        "clear":"Claro"
    }
});

